import React from "react"
import styled from "styled-components"
import { theme, section, BGWrapper, flex } from "@/common/Mixin"

interface SectionRowProps {
  id?: string
  type?: string
  bg?: any
  content1?: any
  content2?: any
  glow?: boolean
}

const SectionRow = ({
  id,
  type,
  bg,
  content1,
  content2,
  glow
}: SectionRowProps) => {
  return (
    <SectionWrapper id={id} className={`${type ? type : ""}`}>
      <BGWrapper>{bg}</BGWrapper>
      <Wrapper className={`${type ? type : ""}`}>
        {content1 && (
          <Content1 className={`${type ? type : ""}`}>
            {/* <Fade></Fade> */}
            {content1}
          </Content1>
        )}
        {content2 && (
          <Content2 className={`${type ? type : ""}`}>
            {/* <Fade style={{ width: "100%" }}></Fade> */}
            {content2}
            {glow && (
              <GlowWrapper>
                <Circle className="c1"></Circle>
                <Circle className="c2"></Circle>
                <Circle className="c3"></Circle>
              </GlowWrapper>
            )}
          </Content2>
        )}
      </Wrapper>
    </SectionWrapper>
  )
}

export default SectionRow

const SectionWrapper = styled.section`
  position: relative;
  ${flex()}
  &.fullHeight {
    height: clamp(100vh, 100%, 100%);
  }
`

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  ${section({ my: "30px" })}

  &.right,
  &.left {
    grid-template-columns: 1fr 1fr;
    min-height: 500px;
    @media (${theme.lg}) {
      grid-template-columns: 1fr;
      margin: 50px 0;
      overflow: hidden;
      min-height: auto;
    }
    @media (${theme.md}) {
      overflow: visible;
      justify-content: center;
      align-items: center;
    }
  }
  &.noY {
    ${section({ py: "0px", my: "0px" })}
  }
  &.noBottom {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  &.noTop {
    margin-top: 0;
    padding-top: 0;
  }
`

const Content1 = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &.right,
  &.left {
    order: 1;
    @media (${theme.lg}) {
      order: 2;
      &.top {
        order: 1;
      }
    }
  }
  &.right {
    order: 2;
  }

  @media (${theme.xl}) {
    position: relative;
    width: 100%;
  }
  @media (${theme.md}) {
    width: 100%;
    position: relative;
    height: auto;
  }
  > .react-reveal {
    width: 100%;
  }
`

const Content2 = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  order: 1;
  gap: 24px;
  /* overflow: hidden; */
  align-items: center;
  justify-content: center;
  > .react-reveal {
    width: 100%;
  }
`
const GlowWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`
const Circle = styled.div`
  --circle: 300px;
  z-index: -1;
  position: absolute;
  width: var(--circle);
  height: var(--circle);
  border-radius: 50%;
  filter: blur(calc(var(--circle) / 2));
  background-color: #fff;
  transform: translate(-50%, -50%);
  /* opacity: 0.5; */
  &.c1 {
    top: 80%;
    left: 50%;
    background: linear-gradient(120deg, rgba(255, 255, 255, 0), #df66fa);
    @media (${theme.md}) {
      --circle: 200px;
    }
  }
  &.c2 {
    top: 40%;
    left: 70%;
    background: linear-gradient(
      270deg,
      rgba(255, 255, 255, 0),
      ${theme.color.primary}
    );
    @media (${theme.md}) {
      --circle: 200px;
    }
  }
  &.c3 {
    --circle: 300px;
    top: 40%;
    left: 30%;
    background: linear-gradient(270deg, rgba(255, 255, 255, 0), #1267e0);
    @media (${theme.md}) {
      --circle: 200px;
    }
  }
`
